import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import MyDataTable from "../../component/MyDataTable";
import { getDateDiff, getPartWarranty } from "../../utils/HelperFunction";
import WarehouseReverse from "./WarehouseReverse";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {EMPLOYEE_TYPE } from "../../constant/status_constant"

const DefectiveChallanGenerate = ({setReverseReload}) => {
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);
  const [reloadList, setReload] = useState(true);
  const [isOpenForm, setOpenForm] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  
      const handleRowSelection = (event, row) => {
      const isChecked = event.target.checked;
      const sc_id = row.sc_id;
  
      if (isChecked) {
        if (selectedRows.length > 0 && selectedRows[0].sc_id !== sc_id) {
          toast.error("Cannot select items from different service centers. Please uncheck previous selections.");
          return;
        }
        //  if (selectedRows.length > 0 && selectedRows[0].warranty_status !== row.warranty_status) {
        //   toast.error("Cannot select items from different Warranty Parts. Please uncheck previous selections.");
        //   return;
        // }
        setSelectedRows([...selectedRows, row]);
        
      } else {
        setSelectedRows(selectedRows.filter((r) => r.id !== row.id));
      }
    };


  const closeForm = () => {
    setOpenForm(false);
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row) => '', // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
     Number(loggedInUser.entity_type) === EMPLOYEE_TYPE &&{
      name: <div className="word-wrap">ASC Name</div>,
      selector: (row) => row?.service_centre?.display_name || "N/A",
      wrap: true,
    },
    {
      name: <div className="word-wrap">Part Requested ID</div>,
      selector: (row) => row.id,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Booking ID</div>,
      selector: (row) => row.booking_detail.booking_id,
      cell: (row) => (
        <NavLink to={`/getbookingdetails?bid=${btoa(row.booking_detail.id)}`}>
          {row.booking_detail.booking_id}
        </NavLink>
      ),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Customer Name</div>,
      selector: (row) => row.booking_detail.user_detail.customer_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Appliance / Brand</div>,
      selector: (row) =>
        `${row.booking_detail.appliance.appliance_name} / ${row.booking_detail.user_appliance_detail.brand.brand_name}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Requested Part Name / Number</div>,
      selector: (row) =>
        `${row.requested_part.part_name} /  ${row.requested_part.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Shipped Part Name/ Number</div>,
      selector: (row) =>
        `${row.shipped_part.part_name} /  ${row.shipped_part.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Requested / Shipped Model Number</div>,
      selector: (row) =>
        `${row.requested_model.model_number} / ${row.shipped_model.model_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Serial Number</div>,
      selector: (row) =>
        row.booking_detail.user_appliance_detail.sf_serial_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Consumption</div>,
      selector: (row) =>
       row.consumption_status?.status || "Part Not Consumed",
      wrap: true,
    },
    {
      name: <div className="word-wrap">Warranty Status</div>,
      selector: (row) => getPartWarranty(row.warranty_status),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Quantity</div>,
      selector: (row) => row.shipped_quantity,
      wrap: true,
    },
    {
      name: "Age",
      selector: (row) =>
        `${getDateDiff(row.booking_detail.sc_closed_date || row.forward_part_ack_date)} days`,
      wrap: true,
    },
    {
      name: "Create",
      cell: (row) => (
        <input
          type="checkbox"
          className="form-control"
          checked={selectedRows && selectedRows.length > 0 && selectedRows.some((r) => r.id === row.id)}
          onChange={(e) => {
            console.log(row)
            handleRowSelection(e, row);
            
          }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    Reverse Challan To be Generated
                  </h3>
                </div>
                <MyDataTable
                  reloadList={reloadList}
                  columns={columns}
                  getDataListURL={`getdefectivetobeshppementlist?isdefective=1`}
                  setReload={setReload}
                  exportName={"partordered"}
                />
              </div>
            </div>
          </div>
        </div>
         {selectedRows.length > 0 && (
              <div className="text-center my-3">
                <button className="btn btn-primary" onClick={() => {
                  setOpenForm(true);
                }}>
                  Create Challan { selectedRows.length > 0 && `(${selectedRows.length})` }
                </button>
              </div>
            )}
        {isOpenForm && (
          <WarehouseReverse
            closeForm={closeForm}
            setReload={setReload}
            selectedRows={selectedRows}
            setEditRow={setSelectedRows}
            setReverseReload={setReverseReload}
          />
        )}
      </section>
    </div>
  );
};

export default DefectiveChallanGenerate;
